import resume from '../assets/pdf/resume.pdf'
import image from "../assets/images/1755526736099.jpeg"

export const headerData = {
    name: 'Sameed Hussain',
    title: "AI Engineer",
    desciption:"An AI Engineer specializing in building end-to-end AI solutions, intelligent agents, and automation powered by custom LLMs.",
    image: image,
    resumePdf: resume
}
